<!--
  ~ Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
@if (tenants) { @if (tenants.length > 0) {
<form
  [formGroup]="environmentLoginFormGroup"
  (click)="$event.stopPropagation()"
  (submit)="loginToTenant()"
>
  <mat-form-field subscriptSizing="dynamic">
    <input
      type="text"
      class="tenant-input"
      placeholder="Search tenants..."
      matInput
      [formControl]="organizationId"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
      @for (tenant of tenantsFiltered$ | async; track tenant) {
      <mat-option [value]="tenant.organizationId">
        <b>{{ tenant.organizationId }}</b>
        - {{ trimTenantName(tenant.name) }}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field subscriptSizing="dynamic">
    <mat-select placeholder="Environment" formControlName="previewEnvironmentName">
      <mat-option [value]="''">Non-preview</mat-option>
      @if (previewEnvironmentsLoadable.data) {
      <mat-optgroup [label]="'Preview environments'">
        @for (previewEnvironment of previewEnvironments; track previewEnvironment) {
        <mat-option [value]="previewEnvironment.environmentName">
          {{ previewEnvironment.environmentName }}
          <i>({{ previewEnvironment.modificationInstant | dateTime: dateTimeFormat }})</i>
        </mat-option>
        }
      </mat-optgroup>
      }
    </mat-select>
  </mat-form-field>
  <div class="form__buttons">
    <button
      mat-raised-button
      [disabled]="!environmentLoginFormGroup.valid"
      (click)="loginToTenant()"
    >
      <i class="material-icons">forward</i>
      Log In
    </button>
  </div>
</form>
} @else {
<div class="status-message">
  <p>Looks like you do not have access to any tenant.</p>
  <p>Ask in #ba-ops for demo/PoCs or raise a Service Desk ticket for prod tenants.</p>
</div>
} } @if (allTenantsLoadable.loading) {
<div class="status-message">Loading tenant data...</div>
} @if (allTenantsLoadable.error) {
<div class="status-message">Could not load tenant data.</div>
} @if (previewEnvironmentsLoadable.loading) {
<div class="status-message">
  Loading preview environments...
</div>
} @if (previewEnvironmentsLoadable.error) {
<div class="status-message">
  Could not load preview environments.
</div>
}
